/**
 * TX Notes API
 * Handles treatment note CRUD for a patient
 *
 * All responses return the updated patient object — callers
 * should update openedPatients in the store with the response.
 */

import { apiClient } from './config';

/**
 * Add a new TX note for a given date
 * Response: { patient: PatientObject }
 */
export const addTxNote = async (customerId, note, date) => {
  const response = await apiClient.post(`/patient/${customerId}/addNote`, { note, date });
  return response.data;
};

/**
 * Update an existing TX note
 * Response: { updatedPatientProfile: PatientObject }
 */
export const updateTxNote = async (customerId, noteId, note) => {
  const response = await apiClient.put(`/patient/${customerId}/note/${noteId}`, { note });
  return response.data;
};

/**
 * Update the single general note for a patient
 * Response: { patient: PatientObject }
 */
export const updateGeneralNote = async (customerId, generalNote) => {
  const response = await apiClient.put(`/updateGeneralNote/${customerId}`, { generalNote });
  return response.data;
};

/**
 * Delete a TX note by ID
 * Response: { updatedPatientProfile: PatientObject }
 */
export const deleteTxNote = async (customerId, noteId) => {
  const response = await apiClient.delete(`/patient/${customerId}/note/${noteId}`);
  return response.data;
};
